import translations from '../../translations';
import type { UserTenantResponseAPI } from '../../types/user';
import ReceivedTenantInviteList from './ReceivedTenantInvites';
import ReceivedUserInviteList from './ReceivedUserInvites';

type NonAdminUI = {
    tenant: UserTenantResponseAPI;
};

const NonAdminUI = ({ tenant }: NonAdminUI) => {
    return (
        <div data-testid="non-admin-ui" className="flow-organization admin-page">
            {tenant?.organization ? (
                <>
                    <h2>{translations.FORG_non_admin_joined_tenant_heading}</h2>
                    <p>
                        {translations.FORG_non_admin_joined_tenant_help_text}{' '}
                        <strong>{tenant.organization.name ?? ''}</strong>
                    </p>
                </>
            ) : (
                <h2>{translations.FORG_non_admin_not_joined_tenant_heading}</h2>
            )}
            <ReceivedTenantInviteList tenant={tenant} />
            <ReceivedUserInviteList />
        </div>
    );
};

export default NonAdminUI;
